import React from 'react';
import styles from './Banner.module.css';
import Button from '../../../shared/ui/button/Button';
import BackgroundShadow from '../shared/BackgroundShadow';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import image from './images/Group.png';

const Banner: React.FC = () => {
    return (
        <div className={styles.container}>
            <BackgroundShadow />
            <div className={styles.leftContainer}>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    Version Control
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                    Version control tracks every change made to your content, allowing you to
                    compare, restore, and collaborate on multiple iterations with full transparency.
                </OptimizedMotionP>
            </div>
            <div className={styles.rightContainer}>
                <img src={image} alt="banner" className={styles.image} />
            </div>
        </div>
    );
};

export default Banner;
